import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProtectedRoutes from './ProtectedRoutes';
import UnprotectedRoutes from './UnprotectedRoutes';

const routes = {
  Index: '/',
  Home: '/home',
  Login: '/login',
  OrdersWithDegree: '/pedidos-com-grau',
  OrdersNonDegree: '/pedidos-nao-grau',
  OrdersHomeTryOn: '/pedidos-zerezes-em-casa',
  Reports: '/relatorios',
  ManageTransport: '/administrar-transporte',
  ManageDnpLinks: '/administrar-links-dnp',
  Customers: '/clientes',
  ManageAmaroIntegrations: '/amaro',
  ListAmaroOrderImports: '/amaro-pedidos-importados',
  AppConfigs: '/configuracoes',
  ExpressOrders: '/pedidos-expresso',
  //other routes...
}

const AppRoutes: React.FC = () => {

  const { session } = useAuth();

  return (
    <Router>
      {session ? <ProtectedRoutes /> : <UnprotectedRoutes />}
    </Router>
  );
}

export { AppRoutes, routes };